const API_BASE_WARD_MENU_LINKS = '/api/wardlinks';

export const wardMenuLinksEndpoints = {
  getLinks: API_BASE_WARD_MENU_LINKS,
  getLinksIds: (ids: number[]) =>
    `${API_BASE_WARD_MENU_LINKS}/ids?${ids.map((id) => `id=${id}`).join('&')}`,
  getLinkById: (id: number) => `${API_BASE_WARD_MENU_LINKS}/${id}`,
  createLink: API_BASE_WARD_MENU_LINKS,
  updateLink: (id: number) => `${API_BASE_WARD_MENU_LINKS}/${id}`,
  deleteLink: (id: number) => `${API_BASE_WARD_MENU_LINKS}/${id}`,
};
